import Handlebars from "handlebars";
import {doNotTranslate} from "@khan/i18n";

export default () => Handlebars.compile(`{{#if isEmpty}}

<div class="achievement-badge compact empty">
  <div id="outline-box">
  <div class="selected-indicator"> </div>
  </div>
</div>

{{else}}

<div class="achievement-badge compact achievement-badge-owned{{#if used}} used{{/if}}"
    id="{{name}}" title="{{translatedExtendedDescription}}">
  <div id="outline-box">
    {{! XSS note: this is safe because toBadgeDescriptionWithBreaks }}
    {{! escapes its argument }}
    <div class="achievement-title">{{{toBadgeDescriptionWithBreaks translatedDescription}}}</div>
    <img class="badge-icon" src="{{staticUrl icons.compact}}">
    <div class="delete-icon">${doNotTranslate`X`}</div>
    <div class="selected-indicator"> </div>
  </div>
</div>

{{/if}}`) as any;
